// extracted by mini-css-extract-plugin
export var component = "Box-module--component--iL3WY";